import { render, staticRenderFns } from "./TopicSelectionPhase.vue?vue&type=template&id=2c16cf20&"
import script from "./TopicSelectionPhase.vue?vue&type=script&lang=js&"
export * from "./TopicSelectionPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports